import httpClient from '@/lib/httpClient'
import { useQuery } from '@tanstack/react-query'

export default function useGetTransactionById({ id } = {}) {
  // const queryClient = useQueryClient()
  const fetchData = async () => {
    // const cachedData = queryClient.getQueryData(['latest-transactions'])
    // const result = cachedData.find((x) => x.id === Number(id))
    const response = await httpClient.get(`/team/cash-flow/transactions/${id}`)
    return response.data.data
  }

  return useQuery({
    queryKey: ['transactions', 'detail', Number(id)],
    queryFn: fetchData,
    enabled: !!id,
  })
}
